var map = {
	"./minimize-two.png": "rCHW",
	"./minimize.png": "p6/4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pPo4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-sidebar ^\.\/minimize.*\.png$
// module id = pPo4
// module chunks = 46